import React, { useState } from 'react';
import { AlertCircleIcon } from 'lucide-react';
export const WithdrawalForm = ({
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    clientId: '',
    clientName: '',
    reason: '',
    description: '',
    attachments: [],
    contactMethod: '',
    contactDetails: ''
  });
  const [errors, setErrors] = useState({});
  const handleSubmit = e => {
    e.preventDefault();
    const newErrors = {};
    // Validation
    if (!formData.clientId) newErrors.clientId = 'Campo requerido';
    if (!formData.clientName) newErrors.clientName = 'Campo requerido';
    if (!formData.reason) newErrors.reason = 'Campo requerido';
    if (!formData.contactMethod) newErrors.contactMethod = 'Campo requerido';
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSubmit(formData);
  };
  const handleFileChange = e => {
    const files = Array.from(e.target.files);
    setFormData(prev => ({
      ...prev,
      attachments: [...prev.attachments, ...files]
    }));
  };
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1254">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1255">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1256">
          <div data-id="element-1257">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1258">
              ID Cliente <span className="text-red-500" data-id="element-1259">*</span>
            </label>
            <input type="text" value={formData.clientId} onChange={e => setFormData({
            ...formData,
            clientId: e.target.value
          })} className={`mt-1 block w-full px-3 py-2 border ${errors.clientId ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`} data-id="element-1260" />
            {errors.clientId && <p className="mt-1 text-sm text-red-600" data-id="element-1261">{errors.clientId}</p>}
          </div>
          <div data-id="element-1262">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1263">
              Nombre Cliente <span className="text-red-500" data-id="element-1264">*</span>
            </label>
            <input type="text" value={formData.clientName} onChange={e => setFormData({
            ...formData,
            clientName: e.target.value
          })} className={`mt-1 block w-full px-3 py-2 border ${errors.clientName ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`} data-id="element-1265" />
            {errors.clientName && <p className="mt-1 text-sm text-red-600" data-id="element-1266">{errors.clientName}</p>}
          </div>
          <div className="md:col-span-2" data-id="element-1267">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1268">
              Motivo de Desistimiento <span className="text-red-500" data-id="element-1269">*</span>
            </label>
            <select value={formData.reason} onChange={e => setFormData({
            ...formData,
            reason: e.target.value
          })} className={`mt-1 block w-full px-3 py-2 border ${errors.reason ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`} data-id="element-1270">
              <option value="" data-id="element-1271">Seleccione un motivo</option>
              <option value="financial" data-id="element-1272">Motivos Financieros</option>
              <option value="personal" data-id="element-1273">Motivos Personales</option>
              <option value="better-offer" data-id="element-1274">Mejor Oferta</option>
              <option value="dissatisfaction" data-id="element-1275">Insatisfacción</option>
              <option value="other" data-id="element-1276">Otros</option>
            </select>
            {errors.reason && <p className="mt-1 text-sm text-red-600" data-id="element-1277">{errors.reason}</p>}
          </div>
          <div className="md:col-span-2" data-id="element-1278">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1279">
              Descripción Detallada
            </label>
            <textarea value={formData.description} onChange={e => setFormData({
            ...formData,
            description: e.target.value
          })} rows={4} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500" data-id="element-1280" />
          </div>
          <div data-id="element-1281">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1282">
              Método de Contacto <span className="text-red-500" data-id="element-1283">*</span>
            </label>
            <select value={formData.contactMethod} onChange={e => setFormData({
            ...formData,
            contactMethod: e.target.value
          })} className={`mt-1 block w-full px-3 py-2 border ${errors.contactMethod ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`} data-id="element-1284">
              <option value="" data-id="element-1285">Seleccione método</option>
              <option value="phone" data-id="element-1286">Teléfono</option>
              <option value="email" data-id="element-1287">Correo Electrónico</option>
              <option value="presential" data-id="element-1288">Presencial</option>
            </select>
            {errors.contactMethod && <p className="mt-1 text-sm text-red-600" data-id="element-1289">
                {errors.contactMethod}
              </p>}
          </div>
          <div data-id="element-1290">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1291">
              Detalles de Contacto
            </label>
            <input type="text" value={formData.contactDetails} onChange={e => setFormData({
            ...formData,
            contactDetails: e.target.value
          })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500" placeholder="Teléfono o correo de contacto" data-id="element-1292" />
          </div>
          <div className="md:col-span-2" data-id="element-1293">
            <label className="block text-sm font-medium text-gray-700" data-id="element-1294">
              Documentos de Soporte
            </label>
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-1295">
              <div className="space-y-1 text-center" data-id="element-1296">
                <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true" data-id="element-1297">
                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" data-id="element-1298" />
                </svg>
                <div className="flex text-sm text-gray-600" data-id="element-1299">
                  <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500" data-id="element-1300">
                    <span data-id="element-1301">Cargar archivos</span>
                    <input id="file-upload" name="file-upload" type="file" className="sr-only" multiple onChange={handleFileChange} data-id="element-1302" />
                  </label>
                  <p className="pl-1" data-id="element-1303">o arrastrar y soltar</p>
                </div>
                <p className="text-xs text-gray-500" data-id="element-1304">
                  PNG, JPG, PDF hasta 10MB
                </p>
              </div>
            </div>
          </div>
        </div>
        {formData.attachments.length > 0 && <div className="mt-4" data-id="element-1305">
            <h4 className="text-sm font-medium text-gray-700" data-id="element-1306">
              Archivos adjuntos:
            </h4>
            <ul className="mt-2 divide-y divide-gray-200" data-id="element-1307">
              {formData.attachments.map((file, index) => <li key={index} className="py-2 flex items-center justify-between" data-id="element-1308">
                  <span className="text-sm text-gray-500" data-id="element-1309">{file.name}</span>
                  <button type="button" onClick={() => {
              const newAttachments = [...formData.attachments];
              newAttachments.splice(index, 1);
              setFormData({
                ...formData,
                attachments: newAttachments
              });
            }} className="text-red-600 hover:text-red-800" data-id="element-1310">
                    Eliminar
                  </button>
                </li>)}
            </ul>
          </div>}
        <div className="flex items-center justify-end space-x-4" data-id="element-1311">
          <button type="button" onClick={() => onSubmit()} className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1312">
            Cancelar
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1313">
            Guardar
          </button>
        </div>
      </form>
    </div>;
};